// 春城卡
const state = {
  // 验证表单
  verify: {
    key: "",
    school: "",
    schoolCode: "",
    name: "",
    // 同意协议
    agree: false,
    // 签名
    signature: "",
    // 日期
    date: ""
  }
};

const mutations = {
  setVerify(state, verify) {
    state.verify = verify;
  },
  clearVerify(state) {
    state.verify = {
      key: "",
      school: "",
      schoolCode: "",
      name: "",
      agree: false,
      signature: "",
      date: ""
    };
  }
};

// sessionStorage

export default {
  namespaced: true,
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/springCard.js